import { combineReducers, Reducer } from 'redux';
import { reducer as formReducer } from 'redux-form';
import accountReducer from './accountReducer';
import userReducer from './userReducer';
import { CombinedStateType } from '../types';
import userAccountReducer from './userAccountReducer';
import accountFarmReducer from './accountFarmReducer';
import farmSectorReducer from './farmSectorReducer';
import notificationReducer from './notificationReducer';
import currentSectorReducer from './currentSectorReducer';
import graphsFilterReducer from './graphsFilterReducer';
import localAccountReducer from './localAccountReducers';
import apiCacheReducer from './apiCacheReducer';

const rootReducer: Reducer<CombinedStateType> = combineReducers({
  account: accountReducer,
  userAccount: userAccountReducer,
  localAccounts: localAccountReducer,
  accountFarm: accountFarmReducer,
  farmSector: farmSectorReducer,
  form: formReducer,
  user: userReducer,
  graphsFilter: graphsFilterReducer,
  notifications: notificationReducer,
  currentSector: currentSectorReducer,
  apiCache: apiCacheReducer,
});

export default rootReducer;
